
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"content\">\n    <div class=\"user\">\n        <div class=\"avater\" style=\"background-image: url(")
    ; __append(escape(avatar))
    ; __append(")\"></div>\n        <div class=\"name\">")
    ; __append(escape(nickname))
    ; __append("</div>\n    </div>\n    <div class=\"gift-name\">送出<span>")
    ; __append(escape(presentName))
    ; __append("</span></div>\n</div>\n<div class=\"gift-img\" style=\"background-image: url(")
    ; __append(escape(presentImg))
    ; __append(")\"></div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/lib/effect/effect-content-box.ejs
// module id = 168
// module chunks = 0